import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 7,
	viewBox: "0 0 14 7",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0.647996 7L0 6.51109L7 0L14 6.51109L13.352 7L7 1.09164L0.647996 7Z" })
});
export default SvgChevronUp;
